module.exports = __webpack_public_path__ + "9b81fb5fb1ddee17e485128d67368e61.svg";